import React from 'react';
import './style.scss';
import shortid from 'shortid';

export interface VMContainerData {
    start: string;
    columnCodes: string[];
    id: number
}

interface Props {
    data: VMContainerData[]
}

function RenderVMContainer(props : Props) {
  const { data } = props;
  return (
    <div className="position-relative mx-1" style={{ maxWidth: 380, width: '100%' }}>
      <svg width="100%" viewBox="0 0 300 416" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2.22266" width="296" height="410.828" rx="17" stroke="#181818" strokeWidth="2" />
        <rect x="257.264" y="122.736" width="30" height="50" fill="#181818" />
        <rect x="258.264" y="188.818" width="28" height="18" stroke="#181818" strokeWidth="1" />
        <rect x="258.264" y="214.592" width="28" height="18" rx="9" stroke="#181818" strokeWidth="1" />
        <rect x="258.264" y="240.365" width="28" height="18" rx="9" stroke="#181818" strokeWidth="1" />
        <rect x="52" y="59.0508" width="196" height="264" rx="17" stroke="#181818" strokeWidth="2" />
        <rect x="56" y="343.4" width="188" height="24.7229" stroke="#181818" strokeWidth="2" />
        <rect x="56" y="364.678" width="188" height="24.7229" stroke="#181818" strokeWidth="2" />
      </svg>
      <div className="vm-config-card-container">
        {data?.map((tray) => (
          <div key={shortid.generate()} className="row-container">
            {tray.columnCodes.map((columnCode) => (
              <div className="card-number" key={`tray${columnCode}`}>
                {columnCode}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(RenderVMContainer);
